<template>
  <form @submit.prevent="$emit('submit', subject)">
    <h3>{{ title }}</h3>
    <label for="name" class="form__label">Name</label>
    <input
      type="text"
      id="name"
      class="form__input"
      v-model="subject.name"
    />

    <fieldset class="color-picker">
      <legend class="color-picker__legend form__label">Color</legend>

      <template v-for="c in subjectColors">
        <input
          type="radio"
          :key="`input-${c.value}`"
          :id="`color-${c.value}`"
          name="subject-color"
          class="color-picker__input"
          :value="c.value"
          v-model="subject.color"
        />
        <label
          :key="`label-${c.value}`"
          :for="`color-${c.value}`"
          class="color-picker__label"
          :style="`--color:${c.value}`"
        >
          {{ c.name }}
        </label>
      </template>
    </fieldset>

    <div class="subject-form__footer">
      <button type="button" class="button button--border button--cancel" @click.prevent="$emit('cancel')">Cancel</button>
      <button type="submit" class="form__submit">Save Subject</button>
    </div>
  </form>
</template>

<script>
import subjectColors from '@/utils/subject-colors'

export default {
  name: 'SubjectForm',

  props: {
    title: {
      type: String,
      default: 'Add a New Subject'
    },

    subject: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      subjectColors
    }
  }
}
</script>

<style lang="scss">
.color-picker {
  margin: 1rem 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(4rem, 1fr));
  gap: .25rem .125rem;
  border: 0;
}

.color-picker__legend {
  display: flex;
  grid-column: 1 / -1;
}

.color-picker__input {
  position: absolute;
  opacity: 0;
  z-index: -1;
}

.color-picker__label {
  padding: .125rem;
  width: 4rem;
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2rem;
  font-size: .8rem;
  text-align: center;
  color: var(--color-page-fg);
  background-color: var(--color, #CFD8DC);
  border: .125rem solid #FFF;

  &:hover,
  &:active {
    border-color: #78909C;
  }

  :focus + & {
    outline: none;
    box-shadow:
      0 0 0 .125rem var(--color-page-bg),
      0 0 0 .25rem #78909C;
  }

  :checked + & {
    border-color: currentColor;
  }
}

.subject-form__footer {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  button {
    margin-left: 1rem;
  }
}
</style>
